<template>
  <div>
    <div class="fm_testimonial_loadmoreData" v-if="showLoadingMoreResults">
      <el-button style="width: 100%" type="success" :loading="loadingMore" plain="" @click="loadNextPageResults">
        ... Click Here to LOAD More Results ...
      </el-button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: ['moreResultsAvailable'],
    data(){
      return {
        loadingMore: false, //could be uses for setting the loading more butten interactive
        searchRequest: {
          responseMode: 'add', //decides if results should be added to or replace existing results
          filterPaginate: 'true'
        }
      }
    },
    computed: {
      showLoadingMoreResults(){
        const currentPage = this.$store.state.mppCurrentPage;
        const numResultsPerPage = this.$store.getters.getMPPResultsPerPageObject.selected;
        const numFilteredResults = this.$store.getters.getMPPFilteredResultsNum;

        //console.log(currentPage * numResultsPerPage);
        //console.log(numFilteredResults);
        if(currentPage * numResultsPerPage < numFilteredResults){
            return true;
        } else {
            return false;
        }
      }
    },
    methods: {
      loadNextPageResults(){
        //like call to action button but rather than replacing results we are adding to them
        this.loadingMore = true;
        this.$store.dispatch('globalActionMPPFetchResults', this.searchRequest).then(response => {
          this.loadingMore = false;
        });


        /*
        //prepare URL
        //const myURL         = this.wpData.fm_admin_ajax_url;
        const mppAjaxURL = "?action=fm_vue_frontend_api_fetch_results";

        //prepare filter data to be passed - filterdata must be JSON ... form data can not work with objects
        const reqData = {
          action: 'fm_vue_frontend_api_fetch_results',
          filterChannel: JSON.stringify(this.$store.getters.getMPPChannels),
          filterNumResPerPage: this.$store.getters.getMPPResultsPerPageObject.selected,
          filterResCurrentPage: this.$store.getters.getMPPResultCurrentPage,
          filterStars: {}
        };

        //console.log(reqData);


        //turn
        const reqFormData = new FormData();
        for ( var key in reqData ) {
          reqFormData.append(key, reqData[key]);
        }

        //contact MPP Backend To Get Filter Data
        axios.post(mppAjaxURL, reqFormData) //example for passing in configuration via 3rd optional parameter.
             .then(response => {

               this.$store.dispatch('addMPPResults', response.data.results);
               this.$store.dispatch('setMPPCurrentPage', response.data.info['current_page']);
               this.loadingMore = false;
             })
             .catch(error => {
               console.log(error);
             });

      */
      }
    }
  }
</script>

<style scoped lang="scss">

</style>